/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPayorSourcePage } from './HchbPayorSourcePage';
import {
    HchbPayorSourcePageFromJSON,
    HchbPayorSourcePageFromJSONTyped,
    HchbPayorSourcePageToJSON,
} from './HchbPayorSourcePage';

/**
 * 
 * @export
 * @interface FindAllHchbPayorSources200Response
 */
export interface FindAllHchbPayorSources200Response {
    /**
     * 
     * @type {HchbPayorSourcePage}
     * @memberof FindAllHchbPayorSources200Response
     */
    data?: HchbPayorSourcePage;
}

/**
 * Check if a given object implements the FindAllHchbPayorSources200Response interface.
 */
export function instanceOfFindAllHchbPayorSources200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbPayorSources200ResponseFromJSON(json: any): FindAllHchbPayorSources200Response {
    return FindAllHchbPayorSources200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPayorSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPayorSources200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbPayorSourcePageFromJSON(json['data']),
    };
}

export function FindAllHchbPayorSources200ResponseToJSON(value?: FindAllHchbPayorSources200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbPayorSourcePageToJSON(value.data),
    };
}

